export const pageRoutes = {
    root: '/',
    home: '/home',
    profile: '/profile',
    accountCreditAdditions: '/account-credit-additions',
    accountPackages: '/account-packages',
    whatsAppGuide: '/whatsapp/guide-and-setup',
    whatsAppTemplates: '/whatsapp/templates',
    whatsAppTemplateNew: '/whatsapp/new-template',
    whatsAppTemplateNewEdit: '/whatsapp/new-template-edit',
    whatsAppTemplateUpdate: '/whatsapp/edit-template/:templateId',
    whatsAppNumbers: '/whatsapp/phone-numbers',
    whatsAppNumberNew: '/whatsapp/new-number',
    whatsAppMessageLink: '/whatsapp/message-link',
    whatsAppBroadcast: '/whatsapp/broadcast',
    whatsAppChannelVerification: '/whatsapp/channel-verification',
    whatsAppBlockedNumbers: '/whatsapp/blocked-numbers',
    apiKeys : '/developer-tools/apikeys',
    addApiKey:'/developer-tools/new-apikeys',
    updateApiKey: '/developer-tools/edit-apikeys/:keyId',
    webHook:'/developer-tools/webhook-settings',
    addWebhook: '/developer-tools/new-webhook-settings',
    updateWebhook: '/developer-tools/update-webhook-settings/:id',
    chatbots: '/conversation-studio/chatbots',
    chatbotGuide: '/conversation-studio/chatbotGuide',
    chatbotBuilderPage: '/conversation-studio/visual-builder',
    chatbotBuilder: '/conversation-studio/visual-builder/:chatbotId',
    chatbotBuilderAttributes: '/conversation-studio/visual-builder/attributes/:chatbotId',
    chatbotBuilderSettings: '/conversation-studio/visual-builder/settings/:chatbotId',
    smsSenderNames: '/sms/sender-names',
    smsSenderNameNew: '/sms/new-sender-name',
    messageLog:'/reports/message-log',
    messageExport:'/reports/message-export',
    customAttributes: '/address-book/custom-attributes',
    contacts: '/address-book/contacts',
    contactGroups: '/address-book/contact-groups',
    contactNew: '/address-book/new-contact',
    contactUpdate: '/address-book/update-contact/:contactId',
    contactUpload: '/address-book/upload-contacts',
    updateContactGroups: '/address-book/edit-contact-groups/:id',
    addContactGroups:'/address-book/new-contact-groups',
    campaigns:'/campaigns',
    campaignNew:'/campaigns/new-campaign',
    campaignUpdate:'/campaigns/update-campaign/:campaignId',
    campaignInformation:'/campaigns/:campaignId',
    campaignSummery:'/campaigns/campaign-summary',
    campaignDetails:'/campaigns/campaign-details/:campaignId',
    receiveMessage:'/reports/receive-message',
    connectorSalla:'/connector/salla',
    createSallaFlow:'/connector/new-salla-flow',
    updateSallaFlow: '/connector/update-salla-flow/:id',
    connectorZid:'/connector/zid',
    createZidFlow:'/connector/new-zid-flow',
    updateZidFlow: '/connector/update-zid-flow/:id',
    zidAuthDummyPage: '/connector/redirect-to-zid-auth',
    zidCallbackDummyPage: '/connector/zid-callback',
    paymentSubscriptionPlans: '/subscription/plans',
    paymentRedirect: '/subscription/redirect',
    paymentCheckout: '/subscription/checkout',
    subscriptionDashboard: '/subscription/dashboard',
    paymentService: '/payment-service',
    paymentSettings: '/payment-service/payment-settings',
    transactions: '/payment-service/transactions',
    chatLinks: '/chat-links',
    chatLinkAnalytics: '/chat-link/analytics/:id',
    instagramOnboarding: '/instagram/onboarding',
    instagramOnboardingRedirect: '/instagram/onboarding-redirect',
}